import * as React from "react";

import styled from "styled-components";
import { getGroupDate } from "../api/api";
import { Breadcrumb, Pagination } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageHeader from "../comp/pageheader";
import { AnyType } from "../util/types";

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .content {
    .list {
      /* flex: 1; */
    }
    .item {
      height: 50px;
      border-bottom: 1px dashed gray;
      font-size: 14px;
      line-height: 50px;
      cursor: pointer;
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
`;

const GroupDate: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const [querys] = useSearchParams();
  const id = querys.getAll("id")[0] || "";

  const [alist, setalist] = React.useState<Array<any>>([]);
  const [total, setTotal] = React.useState(0);
  const [pageno, setpageno] = React.useState(1);
  const [groupInfo, setGroupInfo] = React.useState<AnyType>({});

  const agetList = async () => {
    const ret = await getGroupDate(id);
    setalist(ret?.likeSubjects ?? []);
    setGroupInfo(ret?.group ?? []);
  };

  React.useEffect(() => {
    agetList();
  }, []);

  const goDetail = (x: any) => {
    navigate(`/group/detail?id=${x.groupId}&name=${x.createTimeStr}`);
  };

  return (
    <Container>
      <div className="content">
        <div className="breadCrmb">
          <Breadcrumb>
            <Breadcrumb.Item>
              <span className="p" onClick={() => navigate("/group")}>
                首页
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{groupInfo.name}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="list">
          {alist.map((x) => (
            <div className="item" onClick={() => goDetail(x)} key={`x.id`}>
              {groupInfo.name} {x.createTimeStr} 周会
            </div>
          ))}
          {alist.length === 0 && <div className="jsc fs16 mt50">暂无数据</div>}
        </div>
        {/* <div className="footer h70 mt30">
          <Pagination
            total={total}
            current={pageno}
            pageSize={10}
            onChange={(pg) => setpageno(pg)}
          />
        </div> */}
      </div>
    </Container>
  );
};

export default GroupDate;
